import styled from "styled-components"

export const GhostActionsArea = styled.div`
  position: fixed;
  top: 90px;
  right: 15px;
  text-align: center;
  background-color: ${({theme}) => theme.colors.greys.white};
  border-radius: 3px;
  padding: 15px;
  opacity: 0.4;
  transition: opacity 0.2s;
  box-shadow: ${({theme}) => theme.shadows.mid};
  :hover {
    opacity: 1;
  }
  button {
    box-shadow: ${({theme}) => theme.shadows.high};
  }
`
